import React from 'react'
import { SECTION } from 'utils/section'
import styles from './Footer.module.scss'

export const Footer = () => {
  return (
    <footer id={SECTION.FOOTER} className={styles['section']}>PREFOR &copy; 2025 By Tuomas Kujansuu</footer>
  )
}
